import {IScrollingFilterListing} from '@wearesection/bandai-react-components/organisms/ScrollingFilterListing';
import {Box} from '@mui/material';
import dynamic from 'next/dynamic';
const ScrollingFilterListing = dynamic(
  () => import('@wearesection/bandai-react-components/organisms/ScrollingFilterListing')
);
const ScrollingFilterGame: React.FC<IScrollingFilterListing> = props => {
  return (
    <Box
      sx={{
        paddingTop: {
          xs: '52px',
          md: '80px',
        },
        '& .swiper-container': {
          overflow: 'hidden !important',
        },
      }}
    >
      <ScrollingFilterListing {...props} />
    </Box>
  );
};

export default ScrollingFilterGame;
